export const parseObjectArrayToString = (objectArray: any[]): string => objectArray.map((eachObject: any) => (JSON.stringify(eachObject))).toString();